const initialState = {
  loading: false,
  error: null,
  success: false,
  alta_invitado: "",
  message: "",
  tiposDocumentos: [],
};

export default function invitado(state = initialState, { type, payload }) {
  switch (type) {
    case "SET_LOADING":
      return {
        ...state,
        loading: payload,
      };
    case "SET_ERROR":
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case "SET_SUCCESS":
      return {
        ...state,
        success: payload,
        loading: false,
        error: null,
      };
    case "AGREGAR_INVITADO":
      return {
        ...state,
        alta_invitado: payload,
        success: payload.success === true,
        error: payload.success === false ? payload.message : null,
      };
    case "EDITAR_INVITADO":
      return {
        ...state,
        alta_invitado: payload,
        success: payload.success === true,
        error: payload.success === false ? payload.message : null,
      };
    case "GET_TIPOS_DOCUMENTO":
      return {
        ...state,
        tiposDocumentos: payload,
      };
    default:
      return state;
  }
}
